<script setup lang="ts">
import { OverlayProvider } from '@cloudintellitech/ui'
import { APP_OVERLAY_TARGET } from '@/ui/overlay'
import { locales } from './index'

const settingsStore = useSettingsStore()

// 清理旧版本留在 Body 上的 Element Plus 主题覆盖，由 CIT UI 统一接管。
const elementThemeOverrideProperties = [
  '--el-bg-color',
  '--el-color-primary',
  '--el-color-white',
  '--el-color-black',
  ...Array.from({ length: 9 }, (_, index) => `--el-color-primary-light-${index + 1}`),
  ...Array.from({ length: 9 }, (_, index) => `--el-color-primary-dark-${index + 1}`),
]

function clearElementThemeOverrides() {
  for (const property of elementThemeOverrideProperties) {
    document.body.style.removeProperty(property)
  }
}

watch([
  () => settingsStore.currentColorScheme,
  () => settingsStore.settings.app.lightTheme,
  () => settingsStore.settings.app.darkTheme,
], () => {
  clearElementThemeOverrides()
}, {
  immediate: true,
})
</script>

<template>
  <ElConfigProvider :locale="locales[settingsStore.lang]" :button="{ autoInsertSpace: true }">
    <OverlayProvider :to="APP_OVERLAY_TARGET">
      <slot />
    </OverlayProvider>
  </ElConfigProvider>
</template>
